import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api, rm, formatErr } from "@/lib/api";
import { toast } from "sonner";
import "@/styles/asv.css";

export function AsvMockPay() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/asv/payments/${id}`).then((r) => setP(r.data)).catch(() => setP(false)); }, [id]);
  const go = (success) => api.post(`/asv/payments/${id}/mock`, { success }).then((r) => { window.location.href = r.data.return_url + (success ? "" : "&failed=1"); }).catch((e) => toast.error(formatErr(e)));
  return (
    <div className="asv grid place-items-center p-6" data-testid="asv-mock-pay">
      <div className="asv-card w-full max-w-md p-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-600">Test payment</p>
        <h1 className="asv-display mt-2 text-3xl font-extrabold">All Sports Venues checkout</h1>
        {p === false && <p className="mt-4 text-sm">Payment not found.</p>}
        {p && <><p className="asv-muted mt-3 text-sm">{p.description}</p><p className="asv-display mt-4 text-4xl font-extrabold" data-testid="mock-amount">{rm(p.amount_sen)}</p>
          {p.status === "pending" ? <div className="mt-6 flex gap-2"><button className="asv-btn flex-1" onClick={() => go(true)} data-testid="mock-pay-success">Pay now</button><button className="asv-btn-ghost" onClick={() => go(false)} data-testid="mock-pay-fail">Fail</button></div>
            : <p className="mt-6 text-sm font-bold capitalize">Payment {p.status}</p>}</>}
        <p className="asv-muted mt-6 text-xs">CHIP isn't connected on the platform account yet, so this is a simulated payment.</p>
      </div>
    </div>
  );
}

export function AsvPayReturn() {
  const [sp] = useSearchParams();
  const [p, setP] = useState(null);
  const id = sp.get("payment");
  useEffect(() => {
    let n = 0;
    const poll = () => api.get(`/asv/payments/${id}`).then((r) => { setP(r.data); if (r.data.status === "pending" && n++ < 10) setTimeout(poll, 2000); }).catch(() => setP(false));
    poll();
  }, [id]);
  const ok = p?.status === "paid";
  return (
    <div className="mx-auto max-w-lg py-20 text-center" data-testid="asv-pay-return">
      {!p ? <Loader2 className="mx-auto h-10 w-10 animate-spin" /> : ok ? <CheckCircle2 className="mx-auto h-14 w-14 asv-accent" /> : <XCircle className="mx-auto h-14 w-14 text-red-500" />}
      <h1 className="asv-display mt-4 text-3xl font-extrabold" data-testid="pay-return-status">{!p ? "Checking payment..." : ok ? "Payment received" : p.status === "pending" ? "Payment pending" : "Payment not completed"}</h1>
      {p?.order && <p className="asv-muted mt-2 text-sm">Order {p.order.order_no}</p>}
      <Link to="/account" className="asv-btn mt-8" data-testid="pay-return-account">Go to my bookings</Link>
    </div>
  );
}
